var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "hotEntry" },
    _vm._l(_vm.entries, function (entry) {
      return _c("li", { key: entry.id, staticClass: "hotEntry__entry" }, [
        _c("div", {
          staticClass: "hotEntry__entryImage",
          style: _vm.backgroundImage(entry.image_url),
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hotEntry__entryText" }, [
          _c(
            "a",
            {
              staticClass: "hotEntry__entryTitle",
              attrs: { href: entry.link, target: "_blank" },
            },
            [_vm._v("\n        " + _vm._s(entry.title.rendered) + "\n      ")]
          ),
          _vm._v(" "),
          _c("p", {
            staticClass: "hotEntry__entryLead",
            domProps: { innerHTML: _vm._s(entry.contents) },
          }),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }